import dayjs from 'dayjs';

const AUTH_KEY = 'sayma-auth';

export const StorageService = {
  setAuthKey: value => {
    if (value === undefined) localStorage.removeItem(AUTH_KEY);
    else {
      const TTL = value.ttl;
      const expiry = dayjs().add(TTL, 'hours');
      localStorage.setItem(AUTH_KEY, JSON.stringify({ value, expiry }));
    }
    return true;
  },
  getAuthKey: () => {
    const valueRaw = localStorage.getItem(AUTH_KEY);
    if (!valueRaw) return undefined;
    return JSON.parse(valueRaw);
  },
};
